<template>
    <li :class="['advert-item']" data-item-type="advert" :data-page="item.page">
        <div>
            <a :href="item.link" target="_blank">
                <advert-image
                    :mobile="mobile"
                    :item="item"
                    :scale-of-screen="scaleOfScreen"
                ></advert-image>
            </a>
        </div>
    </li>
</template>

<style scoped lang="scss">
@import "common.css.src/mixins.scss";

li + li {
    margin-top: 10px;
}

li.advert-item {
    height: auto;

    display: block;
    overflow: hidden;

    @include when-desktop() {
        height: auto !important;
    }

    img.full-width {
        width: 100%;
        height: auto;
    }
}
</style>

<script setup lang="ts">
import { type PropType, onMounted, onBeforeUnmount } from "vue";
import { type IAdvertItem } from "../../list-item";
import advertImage from "../common/advert-image.vue";

defineProps({
    item: {
        type: Object as PropType<IAdvertItem>,
        required: true,
    },
    mobile: Boolean,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
});

const emit = defineEmits(["mounted", "unmount"]);

onMounted(() => {
    emit("mounted");
});
onBeforeUnmount(() => {
    emit("unmount");
});
</script>

<script lang="ts">
export default {
    model: {
        prop: "item",
    },
};
</script>
